/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { View } from 'react-native';
import { connect } from 'react-redux';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import { PageContainer } from '../../../components/PageContainer';
import { HeaderScreen } from '../../../components/Header/HeaderScreen';
import { DetailSinistreComponent } from '../../../components/Sinistres/DetailSinistre';

export const FDetailSinistre = (props: any) => {
  const { id } = props.route.params;
  const { user } = props;
  const _list = user.listSinistre && user.listSinistre.data;
  const _datas = _list && _list.filter((elt: any) => elt.id === id);
  let _data = {
    agence: '',
    circonstanceAccident: '',
    dateSinistre: '',
    description: '',
    estimationPrejudice: '',
    heureAccident: '',
    idx: '',
    immatriculation: '',
    nomDeclarant: '',
    numeroPolice: '',
    pieceJointeAgence: '',
    statut: '',
    telephone: '',
    type: '',
    version: '',
    date: '',
  };
  if (_datas && _datas.length > 0) {
    _data = _datas[0];
  }

  return (
    <View style={{ paddingBottom: 40, }}>
      <HeaderScreen
        title="Détails Sinistre"
        type="retour"
        noBreadcrumb={false}
      />
      <PageContainer>
        <DetailSinistreComponent title="Agence" value={_data.agence} />
        <DetailSinistreComponent
          title="Circonstance accident"
          value={_data.circonstanceAccident}
        />
        <DetailSinistreComponent
          title="Date sinistre"
          value={_data.dateSinistre}
        />
        <DetailSinistreComponent
          title="Heure sinistre"
          value={_data.heureAccident}
        />
        <DetailSinistreComponent
          title="Estimation préjudice"
          value={_data.estimationPrejudice}
        />
        {!(_data.type === 'Auto Moto') && (
          <DetailSinistreComponent
            title="Nom déclarant"
            value={_data.nomDeclarant}
          />
        )}

        <DetailSinistreComponent title="Statut" value={_data.statut} />
        <DetailSinistreComponent title="Téléphone" value={_data.telephone} />
        <DetailSinistreComponent title="Type" value={_data.type} />
        <DetailSinistreComponent title="Version" value={_data.version} />
      </PageContainer>
    </View>
  );
};

export const DetailSinistre: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FDetailSinistre);
